export const theme = {
  colors: {
    green: '#c9e437',
    darkBlue: '#252f64',
    blueText: '#22326e',
  },
};
